@if (sessionService.is_admin()) {
<button
  animate.enter="animate-fade-in"
  class="trivia"
  (click)="modalService.openModal('TriviaRegularModal')"
>
  Trivia
</button>
<button
  animate.enter="animate-fade-in"
  class="trivia-rain"
  (click)="modalService.openModal('TriviaRainModal')"
>
  Trivia Rain
</button>
}
